import styles from './Loader.module.scss'

interface LoaderProps {
  /** Spinner edge length in px. Defaults to 20. */
  size?: number
  className?: string
}

/**
 * Internal spinner used by `Button` / `ButtonUtility` while `loading` is
 * true. Inherits its colour from the button text colour via `currentColor`
 * so it automatically follows the variant's foreground token.
 *
 * Decorative — `aria-hidden="true"`; the parent button carries
 * `aria-busy="true"` for screen readers.
 *
 * `prefers-reduced-motion` opts out of the spin animation (the arc stays
 * visible as a static indicator).
 */
export function Loader({ size = 20, className }: LoaderProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      focusable={false}
      className={[styles.spinner, className].filter(Boolean).join(' ')}
    >
      {/* Background ring (faint) */}
      <circle
        cx="10"
        cy="10"
        r="8"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="2"
      />
      {/* Spinning arc — sweeps roughly 270°. */}
      <path
        d="M18 10a8 8 0 0 1-8 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
